import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'

export function chatDraftState(text: string) {
  const { userId, sessionGeneration } = useAuthStore.getState()
  return { chatDraft: { text, userId, sessionGeneration } }
}

export function useChatDraft() {
  const location = useLocation()
  const navigate = useNavigate()
  const [input, setInput] = useState(() => {
    const draft = location.state?.chatDraft
    const auth = useAuthStore.getState()
    return draft?.userId === auth.userId && draft?.sessionGeneration === auth.sessionGeneration && typeof draft?.text === 'string' ? draft.text : ''
  })
  useEffect(() => {
    if (location.state?.chatDraft) navigate(location.pathname, { replace: true, state: null })
  }, [location.pathname, location.state, navigate])
  return [input, setInput] as const
}
